<template>
  <main class="home-page">
    <!-- Hero Section -->
    <section class="hero">
      <div class="hero-background" :style="{ backgroundImage: `url(${backgroundImage})` }"></div>
      <div class="hero-overlay"></div>
      <div class="hero-content">
        <div 
          :class="{ 'text-animate': textAnimate }"
          class="hero-text-container"
        >
          <h1 class="hero-title">新加坡福清会馆</h1>
          <p class="hero-subtitle">联络乡情 · 促进乡谊</p>
        </div>
      </div>
    </section>

    <!-- Feature Cards with Video -->
    <section class="features-section">
      <div class="container">
        <div class="features-layout">
          <div class="video-container">
            <iframe 
              class="feature-video" 
              src="https://www.youtube.com/embed/2E2I0SwdAHo?start=2"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              aria-label="会歌视频"
            ></iframe>
          </div>
          <div class="feature-list-vertical">
            <h2 class="feature-list-header">会馆最新消息</h2>
            <div class="feature-list-scroll-wrap">
              <ul ref="featureList" class="feature-list" @scroll="handleFeatureListScroll">
                <li class="feature-list-item">
                  <span class="feature-title">第16届会馆杯卡啦OK歌唱比赛</span>
                  <a href="#karaoke-2026" class="learn-more-link" aria-label="了解更多：第16届会馆杯卡啦OK歌唱比赛">了解更多</a>
                </li>
                <li class="feature-list-item">
                  <span class="feature-title">第十五届全国中小学现场书法比赛</span>
                  <a href="https://www.poiching.moe.edu.sg/calligraphy2026" class="learn-more-link" aria-label="书法比赛">了解更多</a>
                </li>
                <li class="feature-list-item">
                  <span class="feature-title">新春团拜 欢聚一堂庆丙午马年</span>
                  <a href="#cny-2026" class="learn-more-link" aria-label="了解更多：2026新春团拜">了解更多</a>
                </li>
                <li class="feature-list-item">
                  <span class="feature-title">福清会馆换届 年轻理事占比近六成</span>
                  <a href="#zaobao-86council" class="learn-more-link" aria-label="了解更多：福清会馆换届 年轻专业理事占比近六成">了解更多</a>
                </li>
                <li class="feature-list-item">
                  <span class="feature-title">福清会馆86届理事选举</span>
                  <a href="#86election" class="learn-more-link" aria-label="了解更多：福清会馆86届理事选举">了解更多</a>
                </li>
              </ul>
              <div
                v-if="showCustomScrollbar"
                class="custom-scrollbar-track"
                aria-hidden="true"
              >
                <div
                  class="custom-scrollbar-thumb"
                  :style="{ height: `${scrollThumbHeight}px`, transform: `translateY(${scrollThumbTop}px)` }"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import fuqingBuildingBackground from '@/assets/fuqing-building-background.png';

export default {
  name: 'HomePage',
  data() {
    return {
      backgroundImage: fuqingBuildingBackground,
      textAnimate: false,
      scrollThumbHeight: 0,
      scrollThumbTop: 0,
      showCustomScrollbar: false
    };
  },
  mounted() {
    // Text appears and animates
    setTimeout(() => {
      this.textAnimate = true;
    }, 100);
    this.$nextTick(() => {
      this.updateFeatureListScrollbar();
      window.addEventListener('resize', this.updateFeatureListScrollbar);
    });
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateFeatureListScrollbar);
  },
  methods: {
    handleFeatureListScroll() {
      this.updateFeatureListScrollbar();
    },
    updateFeatureListScrollbar() {
      const listEl = this.$refs.featureList;
      if (!listEl) return;

      const { scrollHeight, clientHeight, scrollTop } = listEl;
      if (scrollHeight <= clientHeight) {
        this.showCustomScrollbar = false;
        this.scrollThumbHeight = 0;
        this.scrollThumbTop = 0;
        return;
      }

      this.showCustomScrollbar = true;
      const trackHeight = clientHeight;
      const thumbHeight = Math.max((clientHeight / scrollHeight) * trackHeight, 36);
      const maxThumbTop = trackHeight - thumbHeight;
      const maxScrollTop = scrollHeight - clientHeight;
      const thumbTop = maxScrollTop > 0 ? (scrollTop / maxScrollTop) * maxThumbTop : 0;

      this.scrollThumbHeight = thumbHeight;
      this.scrollThumbTop = thumbTop;
    }
  },
}
</script>

<style scoped>
.home-page {
  flex: 1;
}

/* Hero Section */
.hero {
  position: relative;
  color: white;
  padding: 3rem 0;
  text-align: center;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  opacity: 0.5;
  z-index: 0;
  transform: translateZ(0);
  pointer-events: none;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.005);
  z-index: 1;
  will-change: auto;
  transform: translateZ(0);
}

.hero-content {
  position: relative;
  z-index: 2;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
}


.hero-text-container {
  opacity: 0;
  transform: translateX(100%) scale(0.8);
  transition: opacity 2s ease-in, transform 2.5s ease-out;
  position: relative;
  z-index: 1;
}

.hero-text-container.text-animate {
  opacity: 1;
  transform: translateX(0) scale(1);
}

.hero-title {
  font-size: 4.5rem;
  margin-bottom: 1rem;
  font-weight: bold;
  letter-spacing: 0.1em;
  font-family: "KaiTi TC", "KaiTi", "楷体", serif;
  color: #ff0000;
}

.hero-subtitle {
  font-size: 2rem;
  opacity: 0.9;
  font-family: "KaiTi TC", "KaiTi", "楷体", serif;
  color: #ff0000;
  font-weight: bold;
}

/* Features Section */
.features-section {
  padding: 4rem 0;
  background: var(--surface);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.features-layout {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 3rem;
}

.video-container {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.feature-video {
  width: 100%;
  max-width: 750px;
  aspect-ratio: 16 / 9;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  border: none;
}

.feature-list-vertical {
  flex: 0 0 400px;
  display: flex;
  flex-direction: column;
}

.feature-list-scroll-wrap {
  position: relative;
  padding-right: 14px;
}

.feature-list-header {
  font-size: 2rem;
  color: var(--primary-color);
  margin-bottom: 2rem;
  font-weight: 600;
}

.feature-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  max-height: 300px;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-bottom: 0.5rem;
  scrollbar-width: none;
  padding-right: 8px;
}

.feature-list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.6rem 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.feature-list-item:last-child {
  border-bottom: none;
  margin-bottom: 0.25rem;
}

.feature-list::-webkit-scrollbar {
  width: 0;
}

.feature-list::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.12);
  border-radius: 999px;
}

.feature-list::-webkit-scrollbar-thumb {
  background: var(--primary-color);
  border-radius: 999px;
}

.custom-scrollbar-track {
  position: absolute;
  top: 0;
  right: 0;
  width: 8px;
  height: 300px;
  background: rgba(0, 0, 0, 0.12);
  border-radius: 999px;
}

.custom-scrollbar-thumb {
  width: 100%;
  background: var(--primary-color);
  border-radius: 999px;
  transition: transform 0.12s ease-out;
}

.feature-title {
  color: var(--text-primary);
  font-size: 1.1rem;
  font-weight: 500;
  flex: 1;
  line-height: 1.0;
}

.feature-list-item::before {
  display: none;
}

.learn-more-link {
  color: var(--primary-color);
  text-decoration: none;
  font-weight: 600;
  font-size: 0.9rem;
  transition: color 0.3s ease;
  white-space: nowrap;
  margin-left: 1rem;
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  padding: 0.5rem 0.75rem;
}

.feature-list .learn-more-link {
  min-height: 36px;
  padding: 0.25rem 0.5rem;
}

.learn-more-link:hover {
  color: var(--primary-dark);
  text-decoration: underline;
}

.learn-more-btn {
  display: inline-flex;
  align-items: center;
  color: var(--primary-color);
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s ease;
  min-height: 44px;
  padding: 0.5rem 1rem;
}

.learn-more-btn:hover {
  color: var(--primary-dark);
}

/* Association Section */
.association-section {
  padding: 3rem 0;
  text-align: center;
  background: white;
}

.association-section h2 {
  font-size: 2.5rem;
  color: var(--text-primary);
  margin-bottom: 0.5rem;
}

.association-subtitle {
  font-size: 1.25rem;
  color: var(--text-secondary);
  margin-bottom: 0.5rem;
}

.milestone-btn {
  display: inline-block;
  padding: 0.75rem 2rem;
  background: var(--primary-color);
  color: white;
  text-decoration: none;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 600;
  margin-top: 1rem;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(200, 16, 46, 0.3);
}

.milestone-btn:hover {
  background: var(--primary-dark);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(200, 16, 46, 0.4);
}

/* Cultural Institute */
.cultural-institute {
  padding: 4rem 0;
  background: var(--surface);
}

.cultural-institute h2 {
  font-size: 2rem;
  margin-bottom: 1rem;
  text-align: center;
}

.institute-description {
  text-align: center;
  color: var(--text-secondary);
  max-width: 800px;
  margin: 0 auto 3rem;
  line-height: 1.8;
}

.institute-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
}

.institute-card {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.institute-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.institute-card h4 {
  color: var(--primary-color);
  margin-bottom: 0.5rem;
  font-size: 1.25rem;
}

.card-subtitle {
  color: var(--text-secondary);
  font-size: 0.9rem;
  margin-bottom: 1rem;
}

.learn-more-link {
  color: var(--primary-color);
  text-decoration: none;
  font-weight: 600;
  display: inline-block;
  margin-top: 1rem;
}

.learn-more-link:hover {
  text-decoration: underline;
}

/* Schools Section */
.schools-section {
  padding: 4rem 0;
  background: white;
}

.schools-section h2 {
  font-size: 2rem;
  margin-bottom: 3rem;
  text-align: center;
}

.schools-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.school-card {
  background: var(--surface);
  padding: 2rem;
  border-radius: 8px;
  border-left: 4px solid var(--primary-color);
  transition: all 0.3s ease;
}

.school-card:hover {
  transform: translateX(4px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.school-card h3 {
  color: var(--primary-color);
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
}

.school-founded {
  color: var(--text-secondary);
  font-size: 0.9rem;
  margin-bottom: 1rem;
  font-style: italic;
}

.school-description {
  color: var(--text-primary);
  line-height: 1.8;
  margin-bottom: 1rem;
}

.school-link {
  color: var(--primary-color);
  text-decoration: none;
  font-weight: 600;
  display: inline-block;
}

.school-link:hover {
  text-decoration: underline;
}

/* Venue Section */
.venue-section {
  padding: 4rem 0;
  background: var(--surface);
}

.venue-section h2 {
  font-size: 2rem;
  margin-bottom: 3rem;
  text-align: center;
}

.venue-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
}

.venue-card {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: all 0.3s ease;
}

.venue-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.venue-card h3 {
  color: var(--primary-color);
  margin-bottom: 0.5rem;
  font-size: 1.25rem;
}

.venue-card p {
  color: var(--text-secondary);
  margin-bottom: 1rem;
}

/* News Section */
.news-section {
  padding: 4rem 0;
  background: white;
}

.news-section h2 {
  font-size: 2rem;
  margin-bottom: 3rem;
  text-align: center;
}

.news-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.news-card {
  background: var(--surface);
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.news-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.news-content h3 {
  color: var(--text-primary);
  margin-bottom: 1rem;
  font-size: 1.25rem;
  line-height: 1.6;
}

.read-more {
  color: var(--primary-color);
  text-decoration: none;
  font-weight: 600;
  display: inline-block;
}

.read-more:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .hero {
    padding: 2rem 0;
    min-height: 150px;
  }

  .hero-title {
    font-size: 2.5rem;
  }

  .hero-subtitle {
    font-size: 1.5rem;
  }

  .features-layout {
    flex-direction: column;
    gap: 2rem;
  }

  .feature-list-vertical {
    flex: 1;
    width: 100%;
  }

  .feature-video {
    max-width: 100%;
  }

  .feature-list-scroll-wrap {
    padding-right: 0;
  }

  .feature-list {
    max-height: none;
    overflow-y: visible;
    overflow-x: visible;
    padding-right: 0;
  }

  .custom-scrollbar-track {
    display: none;
  }

  .feature-list-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
    padding: 1rem;
  }

  .feature-title {
    font-size: 1rem;
    line-height: 1.5;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .learn-more-link {
    margin-left: 0;
    padding: 0.5rem 1rem;
    min-height: 44px;
    display: inline-flex;
    align-items: center;
  }

  .feature-cards,
  .institute-grid,
  .schools-grid,
  .venue-grid,
  .news-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .hero-title {
    font-size: 1.75rem;
    line-height: 1.3;
  }

  .hero-subtitle {
    font-size: 1.25rem;
  }

  .hero-content {
    padding: 0 15px;
  }

  .features-section {
    padding: 2rem 0;
  }

  .container {
    padding: 0 15px;
  }

  .feature-list-header {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .feature-title {
    font-size: 0.95rem;
  }

  .learn-more-link {
    font-size: 0.85rem;
    padding: 0.625rem 0.875rem;
  }
}
</style>

